import React, { useImperativeHandle, forwardRef, useState } from "react";

import "src/styles/submenu.scss";

const Submenu = forwardRef(
  (
    { onChange, submenu = ["Apostar", "Como jogar", "Cotações", "Resultados"] },
    ref
  ) => {
    const [page, setPage] = useState("Apostar");

    const handleChange = (nextPage) => {
      setPage(nextPage);
      onChange(nextPage);
    };

    useImperativeHandle(
      ref,
      () => ({
        reset: () => {
          handleChange("Apostar");
        },
      }),
      [handleChange]
    );

    return (
      <div className="submenu">
        <div className="submenu_container">
          {submenu.map((name) => (
            <button
              key={name}
              className={`${page === name ? "active" : ""}`}
              onClick={() => handleChange(name)}
            >
              <p>{name}</p>
            </button>
          ))}
        </div>
      </div>
    );
  }
);

export default Submenu;



// WEBPACK FOOTER //
// ./src/newDesign/components/submenu.jsx